import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0680d32f&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=0680d32f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0680d32f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0680d32f')) {
      api.createRecord('0680d32f', component.options)
    } else {
      api.reload('0680d32f', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=0680d32f&scoped=true", function () {
      api.rerender('0680d32f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/Dashboard.vue"
export default component.exports